export const BADGE_CATEGORIES = [
  {
    key: 'title_shot',
    label: 'Title Shot',
    badges: [
      {
        type: 'title_shot_winner',
        label: 'Title Shot Winner',
        icon: '/images/title-belt.svg',
        multi: true,
        description: 'Awarded for finishing #1 in the PNP Title Shot pool for an event. Top score takes the belt.',
        criteria: 'Win the PNP Title Shot for any event.',
      },
    ],
  },
  {
    key: 'rare',
    label: 'Rare',
    badges: [
      {
        type: 'white_house_belt',
        label: 'White House Belt',
        icon: '/images/white-house-belt.svg',
        rare: true,
        description: 'A one-time commemorative belt awarded to the PNP Title Shot winner for UFC Freedom 250 at the White House.',
        criteria: 'Win the PNP Title Shot for UFC Freedom 250.',
      },
    ],
  },
  {
    key: 'commissioner',
    label: 'Commissioner',
    badges: [
      { type: 'commissioner_5', label: '5+ Members', icon: '/images/commissioner-bronze.svg', description: 'Run a private pool with at least 5 members.', criteria: 'Commission a pool with 5 or more members.' },
      { type: 'commissioner_10', label: '10+ Members', icon: '/images/commissioner-silver.svg', description: 'Run a private pool with at least 10 members.', criteria: 'Commission a pool with 10 or more members.' },
      { type: 'commissioner_25', label: '25+ Members', icon: '/images/commissioner-gold.svg', description: 'Run a private pool with at least 25 members.', criteria: 'Commission a pool with 25 or more members.' },
      { type: 'commissioner_50', label: '50+ Members', icon: '/images/commissioner-diamond.svg', description: 'Run a private pool with at least 50 members.', criteria: 'Commission a pool with 50 or more members.' },
    ],
  },
  {
    key: 'events_picked',
    label: 'Events Picked',
    badges: [
      { type: 'events_picked_1', label: '1 Event', icon: '/images/events-picked-1.svg', description: 'Submit picks for your first event.', criteria: 'Submit picks for 1 event.' },
      { type: 'events_picked_5', label: '5 Events', icon: '/images/events-picked-5.svg', description: 'Submit picks for 5 different events.', criteria: 'Submit picks for 5 different events.' },
      { type: 'events_picked_10', label: '10 Events', icon: '/images/events-picked-10.svg', description: 'Submit picks for 10 different events.', criteria: 'Submit picks for 10 different events.' },
      { type: 'events_picked_25', label: '25 Events', icon: '/images/events-picked-25.svg', description: 'Submit picks for 25 different events.', criteria: 'Submit picks for 25 different events.' },
      { type: 'events_picked_50', label: '50 Events', icon: '/images/events-picked-50.svg', description: 'Submit picks for 50 different events.', criteria: 'Submit picks for 50 different events.' },
    ],
  },
  {
    key: 'picks_made',
    label: 'Picks Made',
    badges: [
      { type: 'picks_made_10', label: '10 Picks', icon: '/images/picks-made-10.svg', description: 'Submit a total of 10 picks across all pools.', criteria: 'Submit 10 picks across all pools.' },
      { type: 'picks_made_50', label: '50 Picks', icon: '/images/picks-made-50.svg', description: 'Submit a total of 50 picks across all pools.', criteria: 'Submit 50 picks across all pools.' },
      { type: 'picks_made_100', label: '100 Picks', icon: '/images/picks-made-100.svg', description: 'Submit a total of 100 picks across all pools.', criteria: 'Submit 100 picks across all pools.' },
      { type: 'picks_made_500', label: '500 Picks', icon: '/images/picks-made-500.svg', description: 'Submit a total of 500 picks across all pools.', criteria: 'Submit 500 picks across all pools.' },
      { type: 'picks_made_1000', label: '1,000 Picks', icon: '/images/picks-made-1000.svg', description: 'Submit a total of 1,000 picks across all pools.', criteria: 'Submit 1,000 picks across all pools.' },
      { type: 'picks_made_10000', label: '10,000 Picks', icon: '/images/picks-made-10000.svg', description: 'Submit a total of 10,000 picks across all pools.', criteria: 'Submit 10,000 picks across all pools.' },
    ],
  },
  {
    key: 'pick_accuracy',
    label: 'Pick Accuracy',
    badges: [
      { type: 'perfect_main_card', label: 'Perfect Main Card', icon: '/images/perfect-main-card.svg', multi: true, description: 'Pick the winner of every fight on the main card.', criteria: 'Get every main card winner pick correct on a single event.' },
      { type: 'perfect_card', label: 'Perfect Card', icon: '/images/perfect-card.svg', multi: true, description: 'Pick the winner of every fight on the entire card.', criteria: 'Get every winner pick correct (main + prelims + early) on a single event.' },
      { type: 'perfect_method_main', label: 'Perfect Method (Main)', icon: '/images/perfect-method-main.svg', multi: true, description: 'Pick both the winner AND method correctly for every main card fight.', criteria: 'Get winner + method correct for every main card fight on a single event.' },
      { type: 'perfect_method_full', label: 'Perfect Method (Full)', icon: '/images/perfect-method-full.svg', multi: true, description: 'Pick both the winner AND method correctly for every fight on the entire card.', criteria: 'Get winner + method correct for every fight (main + prelims + early) on a single event.' },
    ],
  },
];

export const getEarnedCount = (badges, type) => {
  return badges.filter(b => b.badge_type === type).length;
};

export const isEarned = (badges, type) => {
  return badges.some(b => b.badge_type === type);
};

// Get the badge definition for a given type
export const getBadgeDef = (type) => {
  for (const cat of BADGE_CATEGORIES) {
    const found = cat.badges.find(b => b.type === type);
    if (found) return found;
  }
  return null;
};
